import { mergeClasses, Switch, SwitchOnChangeData } from "@fluentui/react-components";
import { ChangeEvent, memo } from "react";
import { EllipsisTooltip } from "./EllipsisTooltip/EllipsisTooltip";

type RedlineProps = {
  redlined: boolean;
  ontoggleRedlining: (ev: ChangeEvent, data: SwitchOnChangeData) => void;
  styles: Record<string, string>;
};

export const Redline = memo(({ redlined, ontoggleRedlining, styles }: RedlineProps) => {
  return (
    <EllipsisTooltip
      content="Compare your search input against each result"
      positioning={{ position: "above", offset: 0 }}
    >
      <div>
        <Switch
          checked={redlined}
          label={
            <span className={mergeClasses(styles.toolbarToggleLabel, redlined ? styles.toggleActive : "")}>
              Redline
            </span>
          }
          onChange={ontoggleRedlining}
        />
      </div>
    </EllipsisTooltip>
  );
});
